import Navbar from "./Header/Navbar";
import Career from "./Pages/Career";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import BusinessConsulting from "./Services/BusinessConsulting";
import ErpConsulting from "./Services/ErpConsulting";
import ERPEmplimentation from "./Services/ERPEmplimentation";
import MobileDevelopment from "./Services/MobileDevelopment";
import ProductDevelopment from "./Services/ProductDevelopment";
import Home from "./Pages/Home";
import Industries from "./Pages/Industries";
import Footer from "./Pages/Footer";
import Login from "./Pages/Login";
import ProductPage from "./Pages/ProductPage";
import FormData from "./Pages/FormData";
import EditForm from "./Pages/EditForm";
import WebDevelopment from "./Services/WebDevelopment";
import ScrollToTop from "./Pages/ScrollToTop";
import { HashRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
import VisitorTracker from "./Pages/VisitorTracker";
function App() {
  return (
    <>
      <div>
        <HashRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/career" element={<Career />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/consulting" element={<ErpConsulting />} />
            <Route path="/ERPimplementation" element={<ERPEmplimentation />} />
            <Route path="/appdevelopment" element={<MobileDevelopment />} />
            <Route
              path="/productdevelopment"
              element={<ProductDevelopment />}
            />
            <Route
              path="/businessconsulting"
              element={<BusinessConsulting />}
            />
            <Route path="/login" element={<Login />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/form" element={<FormData />} />
            <Route path="/edit" element={<EditForm />} />
           <Route path="/WebDevelopment" element={<WebDevelopment />} />   
          </Routes>
          <VisitorTracker />
          <Footer />
        </HashRouter>
      </div>
    </>
  );
}

export default App;
